import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useTranslation } from 'react-i18next';
import { SimulationTypeEnum } from 'routes/HumanResourcesModule/Simulation/helpers/constants';
import SimulationTypeChip from 'routes/HumanResourcesModule/Simulation/SimulationHome/components/SimulationItem/SimulationTypeChip';

type Props = {
    value: string;
    onChange: (newValue: SimulationTypeEnum) => void;
};

export default function SimulationTypeSelector(
    props: Props,
): React.ReactElement {
    const { t } = useTranslation();
    const { value, onChange } = props;

    const simulationTypes = [
        {
            label: t('humanResources.simulation.projection'),
            value: SimulationTypeEnum.PROJECTION,
        },
        {
            label: t('humanResources.simulation.budgetProposal'),
            value: SimulationTypeEnum.BUDGET_PROPOSAL,
        },
    ];

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl fullWidth>
                <InputLabel>
                    {t('humanResources.simulation.selectType')}
                </InputLabel>
                <Select
                    value={value}
                    onChange={(event) =>
                        onChange(event.target.value as SimulationTypeEnum)
                    }
                    label={t('humanResources.simulation.selectType')}
                >
                    <MenuItem value="" disabled>
                        {t('humanResources.simulation.selectType')}
                    </MenuItem>
                    {simulationTypes.map((type) => (
                        <MenuItem value={type.value} key={type.label}>
                            <SimulationTypeChip type={type.value} />
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    );
}
